module.exports = __webpack_public_path__ + "img/logo-nav.b09ce08c.png";